import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

const Pagenotfound = () => {
  return (
    <>
      <section className="page-title">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <h2>404</h2>
              <ol className="breadcrumb">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>404</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="error-404-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="content clearfix">
                <div className="error">
                  <h2>404</h2>
                </div>
                <div className="error-message">
                  <h3>Oops! Page Not Found!</h3>
                  <p>
                    We’re sorry but we can’t seem to find the page you
                    requested. This might be because you have typed the web
                    address incorrectly.
                  </p>
                  <NavLink to="/" className="theme-btn">
                    Back to home
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Pagenotfound;
